function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import $1DoQa$intlmessageformat from "intl-messageformat";

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
    * Copyright 2020 Adobe. All rights reserved.
    * This file is licensed to you under the Apache License, Version 2.0 (the "License");
    * you may not use this file except in compliance with the License. You may obtain a copy
    * of the License at http://www.apache.org/licenses/LICENSE-2.0
    *
    * Unless required by applicable law or agreed to in writing, software distributed under
    * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
    * OF ANY KIND, either express or implied. See the License for the specific language
    * governing permissions and limitations under the License.
    */
var $d6fd23bc337660df$export$64839e615120df17 = /*#__PURE__*/function () {
  function $d6fd23bc337660df$export$64839e615120df17(messages) {
    var defaultLocale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "en-US";
    _classCallCheck(this, $d6fd23bc337660df$export$64839e615120df17);
    // Clone messages so we don't modify the original object.
    this.messages = _objectSpread({}, messages);
    this.defaultLocale = defaultLocale;
  }
  _createClass($d6fd23bc337660df$export$64839e615120df17, [{
    key: "getStringForLocale",
    value: function getStringForLocale(key, locale) {
      var strings = this.messages[locale];
      if (!strings) {
        strings = $d6fd23bc337660df$var$getStringsForLocale(locale, this.messages, this.defaultLocale);
        this.messages[locale] = strings;
      }
      var string = strings[key];
      if (!string) throw new Error("Could not find intl message ".concat(key, " in ").concat(locale, " locale"));
      return string;
    }
  }]);
  return $d6fd23bc337660df$export$64839e615120df17;
}();
function $d6fd23bc337660df$var$getStringsForLocale(locale, strings) {
  var defaultLocale = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "en-US";
  // If there is an exact match, use it.
  if (strings[locale]) return strings[locale];
  // Attempt to find the closest match by language.
  // For example, if the locale is fr-CA (French Canadian), but there is only
  // an fr-FR (France) set of strings, use that.
  // This could be replaced with Intl.LocaleMatcher once it is supported.
  // https://github.com/tc39/proposal-intl-localematcher
  var language = $d6fd23bc337660df$var$getLanguage(locale);
  if (strings[language]) return strings[language];
  for (var key in strings) {
    if (key.startsWith(language + "-")) return strings[key];
  }
  // Nothing close, use english.
  return strings[defaultLocale];
}
function $d6fd23bc337660df$var$getLanguage(locale) {
  // @ts-ignore
  if (Intl.Locale)
    // @ts-ignore
    return new Intl.Locale(locale).language;
  return locale.split("-")[0];
}

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */
var $972eb555d604f491$export$526ebc05ff964723 = /*#__PURE__*/function () {
  function $972eb555d604f491$export$526ebc05ff964723(locale, messages) {
    _classCallCheck(this, $972eb555d604f491$export$526ebc05ff964723);
    this.locale = locale;
    this.messages = messages;
    this.cache = {};
  }
  _createClass($972eb555d604f491$export$526ebc05ff964723, [{
    key: "format",
    value: function format(key, variables) {
      var message = this.cache[key];
      if (!message) {
        var msg = this.messages.getStringForLocale(key, this.locale);
        if (!msg) throw new Error("Could not find intl message ".concat(key, " in ").concat(this.locale, " locale"));
        message = new (0, $1DoQa$intlmessageformat)(msg, this.locale);
        this.cache[key] = message;
      }
      var varCopy;
      if (variables) varCopy = Object.keys(variables).reduce(function (acc, key) {
        acc[key] = variables[key] == null ? false : variables[key];
        return acc;
      }, {});
      return message.format(varCopy);
    }
  }]);
  return $972eb555d604f491$export$526ebc05ff964723;
}();
export { $d6fd23bc337660df$export$64839e615120df17 as MessageDictionary, $972eb555d604f491$export$526ebc05ff964723 as MessageFormatter };